import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { VariablesContext } from '../../contexts/variablesContext'
import { Input } from 'antd'

interface SearchSectionProps {
  tableLoading: boolean
}

const SearchSection = (props: SearchSectionProps): JSX.Element => {
  const { t } = useTranslation()
  const { tableLoading } = props
  const { variables, setVariables } = useContext(VariablesContext)
  const [searchValue, setSearchValueState] = useState(
    sessionStorage.getItem('searchValue') || ''
  )

  const setSearchValue = (value: string) => {
    sessionStorage.setItem('searchValue', value)
    setSearchValueState(value)
    setVariables((variables: any) => ({ ...variables, search: { value } }))
  }

  return (
    <SearchSectionWrapper>
      <Input.Search
        allowClear={true}
        style={{ width: 400 }}
        size={'large'}
        onSearch={(value, e) => setSearchValue(value)}
        defaultValue={
          searchValue || (variables.search && variables.search.value)
        }
        placeholder={t('search')}
        loading={tableLoading}
      />
    </SearchSectionWrapper>
  )
}

const SearchSectionWrapper = styled.div`
  width: 100%;
  padding: 20px 0 8px 0;
`

export default SearchSection
